import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';

import { MatTableDataSource } from '@angular/material/table';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { ActionItemDto } from '../action-plan-dialog/action-plan-dialog.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-action-item-table',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './action-item-table.component.html',
  styleUrls: ['./action-item-table.component.scss'],
})
export class ActionItemTableComponent implements OnChanges, AfterViewInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() items: ActionItemDto[];
  @Input() selectedItem?: ActionItemDto;
  @Input() disabled: boolean;

  @Output() select = new EventEmitter<ActionItemDto>();

  @ViewChild(MatSort) sort: MatSort;

  dataSource = new MatTableDataSource<ActionItemDto>([]);
  displayedColumns = ['tag', 'name', 'due', 'assignee', 'status'];

  constructor() {
    this.dataSource.sortData = sorting.bind(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.load(changes.items.currentValue);
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  onSelect(item: ActionItemDto): void {
    this.select.emit(item);
  }

  isSelected(item: ActionItemDto): boolean {
    return this.selectedItem === item;
  }

  private load(items: ActionItemDto[]): void {
    this.dataSource.data = items.filter((i) => i.state !== 'deleted');
  }
}

function sorting(data: ActionItemDto[], sort: MatSort): ActionItemDto[] {
  const getStatusValue = (item: ActionItemDto): number => {
    switch (item.status) {
      default:
      case 'NEW':
        return 0;
      case 'IN_PROGRESS':
        return 1;
      case 'COMPLETED':
        return 2;
    }
  };

  return data.sort((a: ActionItemDto, b: ActionItemDto): number => {
    let result = 0;
    switch (sort.active) {
      case 'tag':
        result = a.item_value.localeCompare(b.item_value);
        break;
      case 'name':
        result = a.name.localeCompare(b.name);
        break;
      case 'due':
        result = new Date(a.due_date).getTime() - new Date(b.due_date).getTime();
        break;
      case 'assignee':
        // optional field, empties are last
        if (!a.assignee_user_name) {
          result = 1;
        } else if (!b.assignee_user_name) {
          result = -1;
        } else {
          result = a.assignee_user_name.localeCompare(b.assignee_user_name);
        }
        break;
      case 'status':
        result = getStatusValue(a) - getStatusValue(b);
        break;
    }

    const direction = this.sort.direction === 'asc' ? 1 : -1;
    return result * direction;
  });
}
